import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import axios from "axios";

const LogoContext = createContext(null);
const BASE = process.env.REACT_APP_BACKEND_URL;

export function LogoProvider({ children }) {
  const [info, setInfo] = useState({ logo_path: null, logo_version: 0 });

  const refresh = useCallback(() => axios.get(`${BASE}/api/parametres`).then((r) => setInfo(r.data)).catch(() => {}), []);
  useEffect(() => { refresh(); }, [refresh]);

  const value = useMemo(() => ({
    logoUrl: info.logo_path ? `${BASE}/api/logo?v=${info.logo_version}` : null,
    logoPath: info.logo_path,
    refresh,
  }), [info, refresh]);

  return <LogoContext.Provider value={value}>{children}</LogoContext.Provider>;
}

export const useLogo = () => useContext(LogoContext);
